import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, BarController, BarElement, CategoryScale, LinearScale, Title } from 'chart.js';
import moment from 'moment';
import 'chartjs-adapter-moment';

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Title);

function BarChart({ data }) {
  const colors = [
    'rgba(75,192,192,0.4)',
    'rgba(255,99,132,0.4)',
    'rgba(255,206,86,0.4)',
    'rgba(54,162,235,0.4)',
    'rgba(153,102,255,0.4)',
    'rgba(102,255,102,0.4)',
    'rgba(255,159,64,0.4)',
    'rgba(255,102,255,0.4)',
    'rgba(255,255,0,0.4)',
    'rgba(0,255,0,0.4)',
    'rgba(0,255,255,0.4)',
    'rgba(0,0,255,0.4)',
    'rgba(128,0,0,0.4)',
    'rgba(128,128,0,0.4)',
    'rgba(0,128,0,0.4)',
    'rgba(128,0,128,0.4)',
    'rgba(0,128,128,0.4)',
    'rgba(0,0,128,0.4)',
    'rgba(230,115,0,0.4)',
    'rgba(143,0,255,0.4)'
  ];

  const borderColors = colors.map(color => color.replace('0.4', '1'));
  const hoverColors = colors.map(color => color.replace('0.4', '0.7'));
  

  return (
    <div className="chart-container">
      {data.map((column, index) => {
        const values = column.data.map(item => item[1]);
        const labels = column.data.map(item => item[0]);

        const chartData = {
          labels: labels,
          datasets: [{
            label: column.key,
            type: 'bar',
            data: values,
            backgroundColor: colors[index % colors.length],
            borderColor: borderColors[index % colors.length],
            borderWidth: 1,
            hoverBackgroundColor: hoverColors[index % colors.length],
            hoverBorderColor: borderColors[index % colors.length],
          }]
        };

        const chartOptions = {
          plugins: {
              title: {
                display: true,
                text: column.key,  // Assuming column.key is the title you want to use
                font: {
                  size: 16  // Set the font size of the title
                }
              }
            },
          scales: {
            x: {
              type: 'category',
              labels: labels
            },
            y: {
              type: 'linear',
              beginAtZero: true
            }
          }
        };

        return (
          <div key={index} className="chart-item">
            <Bar data={chartData} options={chartOptions} />
          </div>
        );
      })}
    </div>
  );
}

export default BarChart;
